/*
 * @Description: 慕课数据汇总
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const moocRouter: Array<RouteRecordRaw> = [
    {
        path: '/moocPreviews',
        component: Layout,
        redirect: '/moocPreviews/moocPreview',
        children: [
            {
                path: 'moocPreview',
                component: () => import(/* webpackChunkName: "moocPreview" */ '@/views/moocPage/preview/index.vue'),
                name: 'moocPreview',
                meta: { title: '数据预览' }
            },
            {
                path: 'moocSet',
                component: () => import(/* webpackChunkName: "moocSet" */ '@/views/moocPage/club/set.vue'),
                name: 'moocSet',
                meta: { title: '高级筛选设置' }
            },
            {
                path: 'administration',
                component: () => import(/* webpackChunkName: "administration" */ '@/views/moocPage/index.vue'),
                name: 'administration',
                redirect:'/moocPreviews/administration/courseManage',
                meta: { title: '课程管理' },
                children:[
                    {
                        path: 'courseManage',
                        component: () => import(/* webpackChunkName: "courseManage" */ '@/views/moocPage/club/administration.vue'),
                        name: 'CourseManage',
                        meta: { title: '课程列表' }
                    },
                    {
                        path: 'recycleBin',
                        component: () => import(/* webpackChunkName: "recycleBin" */ '@/views/moocPage/club/recycleBin.vue'),
                        name: 'RecycleBin',
                        meta: { title: '回收站' }
                    },
                    {
                        path: 'detail',
                        component: () => import(/* webpackChunkName: "detail" */ '@/views/moocPage/club/detail.vue'),
                        name: 'MoocClassDetail',
                        meta: { title: '课程详情' }
                    },
                ]
            },
            
            {
                path: 'schoolInformation',
                component: () => import(/* webpackChunkName: "schoolInformation" */ '@/views/moocPage/information/schoolInformation.vue'),
                name: 'schoolInformation',
                meta: { title: '学校信息' }
            }
        ]
    }
]

export default moocRouter
